// quadrant — viewport-relativa kvadranter för gesture-detection.
//
// Indelning (origin = top-left, x → höger, y → ner):
//   TL │ TR
//   ───┼───
//   BL │ BR
// Mitten ligger på (vw/2, vh/2). Punkter på exakta mitten räknas
// som hörnet uppåt-vänster (TL) — godtyckligt val, irrelevant i praktiken
// eftersom user inte träffar exakta centrumkoordinater.

export type Quadrant = 'TL' | 'TR' | 'BL' | 'BR';

export interface Rect {
  width: number;
  height: number;
}

export interface Point {
  x: number;
  y: number;
}

export function quadrantOf(p: Point, viewport: Rect): Quadrant {
  const right = p.x > viewport.width / 2;
  const bottom = p.y > viewport.height / 2;
  if (bottom && right) return 'BR';
  if (bottom && !right) return 'BL';
  if (!bottom && right) return 'TR';
  return 'TL';
}
